export enum threadViewEnum {
  STANDARD = 'standard',
  COMPACT = 'compact',
}
